import { Component } from '@angular/core';
import { ONBOARDING_ID_TOKEN_KEY } from '../constants/local-storage.constant';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, interval, take } from 'rxjs';
import {
  DEFAULT_ROUTE_CONSTANT,
  DESTINATION_KEY_CONSTANT, EM,
  LOGIN_OBJECT_KEY_CONSTANT,
  PRODUCT_KEY_CONSTANT, VERIFY_EMAIL_ROUTE,
} from '../constants/routes.constant';

@Component({
    selector: 'app-email-verification-cta',
    templateUrl: './email-verification-cta.component.html',
    styleUrls: ['./email-verification-cta.component.scss'],
    standalone: false
})
export class EmailVerificationCtaComponent {
  public inProgress: boolean = false;
  private timerSubscription!: Subscription;
  public maxTime: number = 3 * 60; // INFO in ms
  public minutesLeft: number = Math.floor(this.maxTime / 60);
  public secondsLeft: number = 0;
  private productName!: string;
  private destination!: string;
  private loginObject!: string;
  private email!: any;
  private productNameKey: string = PRODUCT_KEY_CONSTANT;
  private destinationKey: string = DESTINATION_KEY_CONSTANT;
  private loginObjectKey: string = LOGIN_OBJECT_KEY_CONSTANT;
  private em: string = EM;
  public queryParams: { [key: string]: string } = {
    [this.productNameKey]: this.productName,
    [this.destinationKey]: this.destination,
    [this.loginObjectKey]: this.loginObject,
  };

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.email = this.activatedRoute.snapshot.paramMap.get(
      this.em
    )!;
    this.productName = this.activatedRoute.snapshot.queryParamMap.get(
      this.productNameKey
    )!;
    this.destination = this.activatedRoute.snapshot.queryParamMap.get(
      this.destinationKey
    )!;
    this.loginObject = this.activatedRoute.snapshot.queryParamMap.get(
      this.loginObjectKey
    )!;

    if (!this.productName || !this.destination) {
      this.router.navigate(DEFAULT_ROUTE_CONSTANT, {
        queryParams: this.queryParams,
        queryParamsHandling: 'preserve',
      });
    }

    this.queryParams = {
      [this.productNameKey]: this.productName,
      [this.destinationKey]: this.destination,
      [this.loginObjectKey]: this.loginObject,
    };

    const totalTime = this.maxTime;

    // INFO every ms (1000) emit numbers from 0...time - 1 (take ensures it stops)
    this.timerSubscription = interval(1000)
      .pipe(take(this.maxTime))
      .subscribe({
        next: (data) => {
          const timeLeft = totalTime - data;
          this.minutesLeft = Math.floor(timeLeft / 60);
          this.secondsLeft = timeLeft % 60;
        },
        complete: () => {
          this.removeIdToken();

          this.router.navigate(DEFAULT_ROUTE_CONSTANT, {
            queryParams: this.queryParams,
            queryParamsHandling: 'preserve',
          });
        },
      });
  }

  ngOnDestroy() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  private removeIdToken() {
    localStorage.removeItem(ONBOARDING_ID_TOKEN_KEY);
  }

  public goToVerificationScreen() {
    const paths = [...VERIFY_EMAIL_ROUTE.split('/'), this.email];

    this.router.navigate(paths, {
      queryParams: this.queryParams,
      queryParamsHandling: 'preserve',
    });
  }
}
